export const isMobileOrTablet = function() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
